<template>
    <div>
        <div v-if="OpenClose" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
            role="dialog" style="display:block">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        {{ msg }}
                        <button type="button" @click="OpenCloseFun()" class="close">x</button>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'center-modal',
    props: [
        'msg',
        'visible'
    ],
    data() {
        return {
            OpenClose: this.visible
        }
    },
    methods: {
        OpenCloseFun() {
            this.OpenClose = false;  
            console.log(this.visible)          
        },
    },
    created() {
        console.log("Hi")
    },
    watch: {
        visible: function (newVal, oldVal) { // watch it
            this.OpenClose = newVal;            
            console.log('new' + newVal + '==' + oldVal)                        
        }
    }
}
</script>